// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3dwRO","list":"PatternAutocomplete_list__36H5e"};